import { BusyButton } from '../BusyButton'
import { useHistory } from '@ztechapps/common.hook'

export const GoBackButton = ({
  text = 'Go Back',
  onClick,
  icon = 'arrow-left',
}: {
  text?: string
  onClick?: () => void
  icon?: string
}) => {
  const history = useHistory()

  const defaultOnClick = () => {
    return history.goBack()
  }

  return <BusyButton text={text} onClick={onClick ?? defaultOnClick} icon={icon} />
}
